import { Link } from "react-router-dom";

export default function AboutSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full">
            <div className="rounded-3xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Editorial%20flat%20lay%20photography%20of%20modern%20lifestyle%20products%20including%20sneakers%20accessories%20and%20bags%20arranged%20aesthetically%20on%20a%20soft%20cream%20surface%2C%20pastel%20mint%20green%20and%20warm%20peach%20color%20palette%2C%20soft%20natural%20lighting%20from%20large%20window%2C%20minimalist%20scandinavian%20style%2C%20clean%20elegant%20composition%2C%20no%20text%20or%20logos%2C%20high%20detail%20product%20photography&width=1000&height=1200&seq=about-flatlay-acbuy-2026&orientation=portrait"
                alt="acbuyspreadsheet product showcase"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>

          <div className="flex-1">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-50 text-accent-700 text-sm font-medium">
              About acbuyspreadsheet
            </span>
            <h2 className="mt-4 text-2xl md:text-4xl font-bold text-foreground-900 font-heading leading-tight">
              Your Complete Buying and Comparison System
            </h2>
            <p className="mt-5 text-foreground-600 leading-relaxed text-sm md:text-base">
              <strong>acbuyspreadsheet</strong> is a powerful spreadsheet-based system designed to simplify data comparison, purchasing workflows, and decision-making processes. Whether you are browsing through product categories, comparing features side by side, or optimizing your buying strategy, acbuyspreadsheet provides the clarity and speed you need.
            </p>
            <p className="mt-4 text-foreground-600 leading-relaxed text-sm md:text-base">
              With an intuitive interface and powerful automation features, the <strong>acbuyspreadsheet</strong> platform brings together all the tools necessary for informed purchasing decisions from detailed product comparisons to streamlined checkout workflows.
            </p>
            <Link
              to="/what-is-acbuyspreadsheet"
              className="mt-6 inline-flex items-center gap-2 px-5 py-3 rounded-lg bg-background-200 text-foreground-800 font-medium text-sm hover:bg-background-300 transition-colors cursor-pointer whitespace-nowrap"
            >
              Read the Full Guide
              <i className="ri-arrow-right-up-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}